import { makeStyles, Theme } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: 240,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCollapsed: {
    width: theme.spacing(7) + 1,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerPaper: {
    width: 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#bbb',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
  },
  drawerPaperCollapsed: {
    width: theme.spacing(7) + 1,
    overflowX: 'hidden',
    overflowY: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  list: {
    flex: 1,
  },
  login: {
    marginLeft: 'auto',
  },
  link: {
    textDecoration: 'none',
    color: COLORS.FONT,
    '& .MuiListItemIcon-root': {
      color: 'inherit',
      minWidth: 40,
    },
    '& .MuiListItem-root': {
      color: 'inherit',
    },
  },
  activeLink: {
    textDecoration: 'none',
    color: COLORS.PRIMARY,
    '& .MuiListItemIcon-root': {
      color: COLORS.PRIMARY,
    },
    '& $menuLabel': {
      color: COLORS.PRIMARY,
      fontWeight: FONT_WEIGHT.medium,
    },
  },
  menuLabel: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.medium,
    color: 'inherit',
  },
  listItemIcon: {
    color: 'inherit',
  },
  icon: {
    marginBottom: 4,
    marginTop: 4,
  },
}))

export { useStyles }
